import { render, staticRenderFns } from "./gameDetails.vue?vue&type=template&id=14c402aa&scoped=true"
import script from "./gameDetails.vue?vue&type=script&lang=js"
export * from "./gameDetails.vue?vue&type=script&lang=js"
import style0 from "./gameDetails.vue?vue&type=style&index=0&id=14c402aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c402aa",
  null
  
)

export default component.exports